<template>
    <div id="pricing">
        <section id="pricing-section" :class="`${transparent ? `transparent` : ``}`">
            <div class="container-fluid px-0">
                <div class="row justify-content-between">
                    <div class="col-12">
                        <div class="intro-message position-relative" data-aos="fade-up" data-aos-duration="1200">
                            <h2 class="section-title px-0 px-lg-5 text-lg-left text-center">Pay As You Grow</h2>
                            <span class="section-title sub-title mb-5 px-0 px-lg-5  text-lg-left text-center">Your Subscription Can Be Scaled up or Down at Any Time</span>
                            <button @click="swipeLeft" class="btn btn-next btn-next-style left-btn d-lg-block d-none"><i class="fas fa-arrow-left"></i> Back</button>
                            <button @click="swipeRight" class="btn btn-next btn-next-style d-lg-block d-none">Next <i class="fas fa-arrow-right"></i></button>
                            <div v-dragscroll  @wheel="scrollHorizontal" :style="`${commission ? `padding-bottom: 40px` : ``}`" class="scrolling-wrapper d-none d-lg-flex" ref="content"  data-aos="fade-up" data-aos-duration="1200">
                                <div v-for="(step, i) in steps" :key="i" class="card wallpaper-card mx-5">
                                    <div class="position-absolute w-100 h-100 background-mask" :style="getGradient(step.background)"></div>
                                    <img :src="step.img" class="position-absolute w-100 h-100 wallpaper-img" :alt="`pay as you grow $${step.title}`">
                                    <div class="steps-icon">
                                        <i :class="`fas ${step.floatingImg}`" :style="`color: ${step.color}`"></i>
                                    </div>
                                    <div class="card-header pb-0 wallpaper-card-header">
                                        <span class="card-num" :style="getColor(step.color)">#{{ i + 1 }}</span>
                                    </div>
                                    <div class="card-body wallpaper-card-body pt-0">
                                        <h5 class="card-title font-weight-bold">
                                            <span v-if="i !== 5" class="dollar-sign font-weight-light">$</span>{{ step.title }}<span v-if="(i !== 0) && (i !== 5)" class="per-month"> / mo</span>
                                        </h5>
                                        <h5 class="card-sub-title font-weight-bold">{{ step.subTitle }}</h5>
                                        <p class="card-text">{{ step.content }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="px-4 d-lg-none">
                                <div v-for="(step, i) in steps" :key="i" class="card wallpaper-card my-4 mx-2" data-aos="fade-up" data-aos-duration="1200">
                                    <div class="position-absolute w-100 h-100 background-mask" :style="getGradient(step.background)"></div>
                                    <img :src="step.img" class="position-absolute w-100 h-100 wallpaper-img" :alt="`pay as you grow $${step.title}`">
                                    <div class="steps-icon">
                                        <i :class="`fas ${step.floatingImg}`" :style="`color: ${step.color}`"></i>
                                    </div>
                                    <div class="card-header pb-0 wallpaper-card-header">
                                        <span class="card-num" :style="getColor(step.color)">#{{ i + 1 }}</span>
                                    </div>
                                    <div class="card-body wallpaper-card-body pt-0">
                                        <h5 class="card-title font-weight-bold">
                                            <span v-if="i !== 5" class="dollar-sign font-weight-light">$</span>{{ step.title }}<span v-if="(i !== 0) && (i !== 5)" class="per-month"> / mo</span>
                                        </h5>
                                        <h5 class="card-sub-title font-weight-bold">{{ step.subTitle }}</h5>
                                        <p class="card-text">{{ step.content }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="text-left mb-2 pl-5 ml-1" style="font-size: 14px" v-if="commission">
                                *The credit card clearing commissions will be added to the monthly fee.
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
    import { dragscroll } from 'vue-dragscroll';

    export default {
        name: 'pricing',
        directives: {
            'dragscroll': dragscroll
        },
      props:['commission', 'transparent'],
        data () {
            return {
                steps: [
                    {
                        title: '0',
                        subTitle: 'Launch Online With No Risk',
                        content: 'We give you 7 days free.',
                        icon: '/img/saas/step1.svg',
                        img: '/img/saas/pricing1.jpg',
                        floatingImg: 'fa-dove',
                        background: 'linear-gradient(119deg, #c83a27 3%, #f37969 97%)',
                        color: '#b61905',
                    },
                    {
                        title: '350',
                        subTitle: 'Make Your Dream Come True',
                        content: 'Up to 100 monthly users.',
                        icon: '/img/saas/step2.svg',
                        img: '/img/saas/pricing2.jpg',
                        floatingImg: 'fa-helicopter',
                        background: 'linear-gradient(120deg, #1b8742 1%, #3dcf71 99%)',
                        color: '#058031',
                    },
                    {
                        title: '500',
                        subTitle: 'Lifestyle Business',
                        content: 'Up to 1000 monthly users.',
                        icon: '/img/saas/step3.svg',
                        img: '/img/saas/pricing3.jpg',
                        floatingImg: 'fa-plane',
                        background: 'linear-gradient(132deg, #f0b641 1%, #ffd47d 98%)',
                        color: '#d19c33',
                    },
                    {
                        title: '900',
                        subTitle: 'Highly Profitable Business',
                        content: 'Up to 10,000 monthly users.',
                        icon: '/img/saas/step4.svg',
                        img: '/img/saas/pricing4.jpg',
                        floatingImg: 'fa-fighter-jet',
                        background: 'linear-gradient(132deg, #30AEB3 1%, #77D9DE 98%)',
                        color: '#0B999F',
                    },
                    {
                        title: '1500',
                        subTitle: 'Successful Company',
                        content: 'Up to 150,000 monthly users.',
                        icon: '/img/saas/step4.svg',
                        img: '/img/saas/pricing5.jpg',
                        floatingImg: 'fa-rocket',
                        background: 'linear-gradient(101deg, #771bae 2%, #9232bf 56%, #3a71bb 96%)',
                        color: '#681a94',
                    },
                    {
                        title: 'Contact Us',
                        subTitle: 'Unicorn Is in the House',
                        content: 'Enterprises And Happy Clients.',
                        icon: '/img/saas/step4.svg',
                        img: '/img/saas/pricing6.jpg',
                        floatingImg: 'fa-space-shuttle',
                        background: 'linear-gradient(101deg, #1C231F 2%, #424543 56%, #606160 96%)',
                        color: '#000000',
                    },
                ],
            }
        },
        methods: {
            getGradient(gradient) {
                return {
                    backgroundImage: gradient,
                }
            },
            getColor(color) {
                return {
                    color: color,
                }
            },
            getImg(img) {
                return {
                    backgroundImage: `url(${img})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'top',
                }
            },
            scrollTo(element, scrollPixels, duration) {
                const scrollPos = element.scrollLeft;
                // Condition to check if scrolling is required
                if ( !( (scrollPos === 0 || scrollPixels > 0) && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0)))
                {
                    // Get the start timestamp
                    const startTime =
                        "now" in window.performance
                            ? performance.now()
                            : new Date().getTime();

                    function scroll(timestamp) {
                        //Calculate the timeelapsed
                        const timeElapsed = timestamp - startTime;
                        //Calculate progress
                        const progress = Math.min(timeElapsed / duration, 1);
                        //Set the scrolleft
                        element.scrollLeft = scrollPos + scrollPixels * progress;
                        //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
                        if (timeElapsed < duration) {
                            //Request for animation
                            window.requestAnimationFrame(scroll);
                        } else {
                            return;
                        }
                    }
                    //Call requestAnimationFrame on scroll function first time
                    window.requestAnimationFrame(scroll);
                }
            },
          scrollHorizontal(e){
             //WHEEL EVENT
          },
            swipeLeft() {
                const content = this.$refs.content;
                this.scrollTo(content, -696, 1200);
            },
            swipeRight() {
                const content = this.$refs.content;
                this.scrollTo(content, 696, 1200);
            }
        },
    }
</script>

<style lang="css" scoped>
    #pricing-section {
        background-color: #f1f1f1;
        overflow: hidden;
        content: "";
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        position: relative;
        color: #000000;
        min-height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
    .transparent{
      background: transparent !important;
      color: #fff !important;
      border: none !important;
    }
    .section-title {
        font-size: 45px;
        font-weight: 300;
        line-height: 1;
    }
    .sub-title {
        font-size: 20px;
        margin-bottom: 50px;
    }
    .intro-message {
        padding-top: 50px;
        padding-bottom: 120px;
    }
    .wallpaper-img {
        z-index: 1;
        object-fit: cover;
        object-position: center;
        border-radius: 30px;
    }
    .background-mask {
        z-index: 2;
        opacity: 0.95;
        border-radius: 30px;
    }
    .wallpaper-card {
        border-radius: 30px;
        box-shadow: 7px 7px 11px 0 rgba(0, 0, 0, 0.16);
        width: auto;
        color: #fff;
        border: 0;
        display: flex;
        margin: auto;
        margin-top: 100px !important;
    }
    .wallpaper-card-body, .wallpaper-card-header {
        z-index: 4;
        border: none;
        box-shadow: none;
        background-color: transparent;
    }
    .card-num {
        font-size: 120px;
        font-weight: 600;
    }
    .scrolling-wrapper {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 100px;
        padding-top: 75px;
        cursor:grab;
    }
    .steps-icon {
        position: absolute;
        z-index: 5;
        right: -35px;
        top: -35px;
    }
    .steps-icon i {
        font-size: 180px;
        transform: rotate(-20deg);
    }
    .scrolling-wrapper .card {
        flex: 0 0 auto;
    }
    .btn-next {
        height: 48px;
        min-width: 160px;
        border-radius: 21px;
        cursor: pointer;
        font-size: 20px;
        border: none;
        outline: none;
    }
    .btn-next-style {
        position: absolute;
        right: 20px;
        top: 60px;
        color: #000;
        background: #DEDEDE;
    }
    .left-btn {
        right: 200px;
    }
    .btn-next-style:hover {
        color: #3d3d3d;
        background: #f4f4f4;
    }
    .wallpaper-card {
        border-radius: 30px;
        box-shadow: 7px 7px 11px 0 rgba(0, 0, 0, 0.16);
        width: 35vw;
        max-width: 600px;
        color: #fff;
    }
    .wallpaper-card .card-title {
        font-size: 36px;
    }
    .wallpaper-card .card-sub-title {
        font-size: 20px;
    }
    .wallpaper-card-body, .wallpaper-card-header {
        z-index: 4;
        border: none;
        box-shadow: none;
    }
    .card-num {
        font-size: 120px;
        font-weight: 600;
    }
    .scrolling-wrapper {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 100px;
    }
    .scrolling-wrapper .card {
        flex: 0 0 auto;
    }
    @media (max-width: 767px) {
        .wallpaper-card {
            width: auto;
        }
        .card-num {
            font-size: 100px;
        }
        .steps-icon i {
            font-size: 145px;
            transform: rotate(-20deg);
        }
        .section-title {
            font-size: 30px;
        }
        .sub-title {
            font-size: 18px;
            width: 330px;
            display: block;
            margin: auto;
        }
    }
    .dollar-sign {
        font-size: 28px;
        vertical-align: top;
    }
    .per-month {
        font-size: 24px;
    }
</style>
